// What a card says of a note his sorter has placed (sim-server world/Sorter.js, 31 Oct). With a sorter of his the line
// is no longer the order they came, so a note of yours waiting says where it put it; and one at the back that expired
// says it was set there, by his sorter or by Glint looking first for him, and not that he let it go.

// and roughly when he will read it, once the town says (sim-server world/ShrineLanes.js, 3 Nov: of the last 200 notes
// 91 had expired, people said so on instagram, and the card said "waiting at the back" for a note that would never be
// read). a guess, said as one: the town reckons it from where the note is in the queue
/** Roughly when he will read it, in words: "he should read it in about 3 hours". null without a time. */
export function etaWords(eta, now = Date.now()) {
  const t = Number(eta)
  if (!Number.isFinite(t) || t <= 0) return null
  const h = (t - now) / 3_600_000
  if (h <= 0.25) return 'he should read it soon'
  if (h <= 1) return 'he should read it within the hour'
  if (h < 1.5) return 'he should read it in about an hour'
  if (h < 20) return `he should read it in about ${Math.round(h)} hours`
  if (h < 36) return 'he should read it by this time tomorrow'
  return `he should read it in about ${Math.round(h / 24)} days`
}

/** A note of yours waiting, as his sorter has it, or null when no sorter has placed it. */
export function sortedWaiting(s = {}, now = Date.now()) {
  const when = etaWords(s.eta, now)
  if (when) return `waiting, ${when}`
  if (s.sorted === 'back') return 'waiting at the back, where his sorter set it'
  if (s.sorted === 'front' || s.sorted === 'next') return 'waiting, his sorter put it in front of him'
  return null
}

/** A note of yours that expired: whether it was at the back, and by whom. */
export function expiredWords(s = {}) {
  if (s.expiredWhy === 'aside') return 'Glint set it aside for him, and it expired before he got to it'
  if (s.expiredWhy === 'back') return 'his sorter set it to the back, and it expired before he got to it'
  return 'expired before he got to it'
}
